import {DataType} from "@app/models/shared/datatype.enum";

export class PageContentFunction
{
  id:number;
  categoryName:string;
  functionName:string;
  functionId:number;
  isChecked:boolean;
  dataType:DataType;
}
